import { render } from "./DownloadDetail.vue?vue&type=template&id=de17c354"
import script from "./DownloadDetail.vue?vue&type=script&lang=js"
export * from "./DownloadDetail.vue?vue&type=script&lang=js"

import "./DownloadDetail.vue?vue&type=style&index=0&id=de17c354&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__